export default __webpack_public_path__ + "static/media/SignPainter.5f2efb8d.woff";